/**
 * Przypisanie starych logow rozmow (/ai/call-logs — proxy do Flaska) do agenta Reach.
 *
 * Te logi nie niosa numerycznego id agenta Reach, wiec front dopasowywal je po polu
 * `initiated_by`, czyli po NAZWIE. Przy dwoch agentach o tej samej nazwie kazdy z nich
 * pokazywal komplet cudzych rozmow (#315). Logi z reach_call_log tego problemu nie maja,
 * bo ida po `agent_id`.
 *
 * Jedyne pewne powiazanie to `elevenlabs_agent_id` — backend potwierdzil zapytaniem, ze
 * jest unikalny 1:1 (2026-08-18). Nie wiadomo natomiast, czy Flask w ogole zwraca to id
 * w polu `agent_id`; tego nie da sie sprawdzic z tego repo. Dlatego nazwa zostaje jako
 * dopasowanie zapasowe, ale wylacznie gdy wskazuje jednego agenta. Log niejednoznaczny
 * nie trafia do nikogo — pokazanie go pod kazdym imiennikiem to dokladnie ten blad.
 */
/**
 * Trzy sposoby wskazania agenta, kazdy z innego zrodla: `id` identyfikuje logi Reach,
 * `elevenlabsAgentId` stare logi Flaska, `name` jest ostatnia deska ratunku. Agenci
 * dorobieni z logow Flaska maja wylacznie nazwe.
 */
export interface AgentIdentity {
  name: string;
  id?: number;
  elevenlabsAgentId?: string;
}

export interface FlaskCallLog {
  agent_id?: string;
  initiated_by?: string;
}

export function flaskLogsOfAgent<T extends FlaskCallLog>(
  logs: T[],
  agent: AgentIdentity,
  allAgents: AgentIdentity[]
): T[] {
  const knownElevenlabsIds = new Set(
    allAgents.map(a => a.elevenlabsAgentId).filter(Boolean)
  );
  const nameIsAmbiguous =
    allAgents.filter(a => a.name === agent.name).length > 1;

  return logs.filter(log => {
    const logAgentId = log.agent_id || '';
    // Id rozpoznane jako agent ElevenLabs rozstrzyga samo — takze wtedy, gdy wskazuje
    // kogos innego niz agent o pasujacej nazwie.
    if (knownElevenlabsIds.has(logAgentId)) {
      return logAgentId === agent.elevenlabsAgentId;
    }
    return !nameIsAmbiguous && log.initiated_by === agent.name;
  });
}
